import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { usePageTransition } from './PageTransition.jsx'

const TransitionLink = React.forwardRef(function TransitionLink(
  { to, children, onClick, ...rest },
  ref
) {
  const transition = usePageTransition()
  const location = useLocation()

  const handleClick = (e) => {
    onClick?.(e)
    if (e.defaultPrevented) return
    if (to === location.pathname) return
    e.preventDefault()
    if (transition) transition.navigateWithTransition(to)
  }

  return (
    <Link to={to} ref={ref} onClick={handleClick} {...rest}>
      {children}
    </Link>
  )
})

export default TransitionLink
